module.exports = __webpack_public_path__ + "img/engicon.ee102d90.png";